import React, { Component } from "react";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import CtBtn from "./CustomTool/CtBtn";
import TableList from "./CustomTool/TableList";
import { withRouter } from "../HOC/withRouter";
import { connect } from "react-redux";
import {
  mapSetActiveMenu_MenuVisibility_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { Grid } from "@mui/material";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";

class VehicleMaster extends Component {
  state = {
    OwnerName: [],
    formData: {
      txtVehicleNo: "",
    },
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      // { id: 'bint_srno', label: 'SR NO' },
      { id: "vehicleno", label: "Vehicle No." },
      { id: "ownername", label: "Owner Name" },
      { id: "mobileno", label: "Mobile No." },
    ],
    searchData: {
      vehicleno: "",
      ownername: "",
      mobileno: "",
    },
    rows: [],
    searchColumns: [],
    rowsCount: 0,
    counter: 0,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Vehical Master";
    this.props.setActiveMenu("VehicleMaster");
    this.setSearchColumns();
    this.props.verifyUserID(
      undefined,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region Handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleOnSearchChange = (searchOpen) => {
    let searchRows = [];
    if (searchOpen === true && this.state.rows.length > 0) {
      this.state.rows.map((row) => {
        if (
          searchOpen === true &&
          (this.state.searchData.vehicleno.length === 0 ||
            (row["vehicleno"]
              ? row["vehicleno"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.vehicleno.toLowerCase())
              : false)) &&
          (this.state.searchData.ownername.length === 0 ||
            (row["ownername"]
              ? row["ownername"]
                  .toString()
                  .toLowerCase()
                  .includes(this.state.searchData.ownername.toLowerCase())
              : false)) &&
          (this.state.searchData.mobileno.length === 0 ||
            (Number(row["mobileno"])
              ? row["mobileno"].includes(this.state.searchData.mobileno)
              : false))
        ) {
          searchRows.push(row);
        }
      });
      const searchRowsCount = searchRows.length;
      this.setState(
        {
          searchOpen,
          searchRows,
          searchRowsCount,
          counter: this.state.counter + 1,
        },
        () => {
          // console.log('searchRows on end of Function', searchRows)
        }
      );
    } else {
      this.setState({ searchOpen });
    }
  };

  handleOnSearchInputChange = (e) => {
    this.setState(
      {
        searchData: {
          ...this.state.searchData,
          [e.target.name]: e.target.value,
        },
      },
      () => {
        this.handleOnSearchChange(this.state.searchOpen);
        // console.log(this.state.searchData)
      }
    );
  };
  //#endregion

  setSearchColumns = () => {
    let searchColumns = [];
    searchColumns.push(
      {
        cType: "CtTxt",
        id: "vehicleno",
        label: "Vehicle No",
        value: this.state.searchData.vehicleno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "ownername",
        label: "Owner Name",
        items: this.state.OwnerName,
        value: this.state.searchData.ownername,
        handleOnChange: this.handleOnSearchInputChange,
        width: "260",
        maxLength: "100",
      },
      {
        cType: "CtTxt",
        id: "mobileno",
        label: "Mobile No.",
        value: this.state.searchData.mobileno,
        handleOnChange: this.handleOnSearchInputChange,
        width: "150",
        maxLength: "100",
      }
    );
    this.setState({ searchColumns });
  };

  render() {
    return (
      <div>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "30px", color: "#515151" }}>
            <b>Vehicle Master</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={0}
          marginTop={0}
        >
          <Grid item>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={2}
              marginTop={0}
            >
              <Grid item>
                <CtTxt
                  id="txtVehicleNo"
                  value={this.state.formData.txtVehicleNo}
                  label="Vehicle No."
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={100}
                />
              </Grid>
              <Grid item>
                <CtCmb
                  id="cmbOwnerName"
                  label="Owner Name"
                  items={this.state.OwnerName}
                  width={150}
                />
              </Grid>
              <Grid item>
                <CtTxt
                  id="txtMobileNo"
                  value={this.state.txtGroupName}
                  label="Mobile No."
                  handleOnChange={this.handleOnChange}
                  width={170}
                  maxLength={100}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
              marginTop={2}
            >
              <Grid item>
                <CtBtn label="Save" />
              </Grid>
              <Grid item>
                <CtBtn label="New" onClick={this.clearInfo} />
              </Grid>
              <Grid item>
                <CtBtn label="Delete" />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          marginTop={5}
        >
          <TableList
            columns={this.state.columns}
            counter={this.state.counter}
            // rows={rows}
            // rowsCount={rowsCount}
            rowsPerPage={this.state.rowsPerPage}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            handleOnActionClick={this.handleARDonActionClick}
            actionList={this.state.actionList}
            keyColumn={this.state.keyColumn}
            handleOnSearchChange={this.handleOnSearchChange}
            searchColumns={this.state.searchColumns}
            searchData={this.state.searchData}
            provideSearch={true}
            // handleOnNewEntryClick={this.handleOnNewEntryClick}
            // toolTipNewEntry='New Product Entry'
          />
        </Grid>
      </div>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(VehicleMaster)));
